import './Settings.css'
import { SupervisoryLevel, LDOLevels, ColdStartAccuracy } from './Cards'
import { useRef } from 'react'

export default function Settings() {

	const panel = useRef()

	const toggleSettings = () => {
		panel.current.classList.toggle('toggled');
	}

	return (
		<div className="settings flex-shrink-1 container" ref={panel}>
			<div className="button-container">
				<button className="settings-toggler" onClick={toggleSettings}>
					<i className="bi bi-sliders"></i>
				</button>
			</div>
			<div className="settings-container">
				<SupervisoryLevel />
				<LDOLevels />
				<ColdStartAccuracy />
			</div>
		</div>
	)
}
